import { render, staticRenderFns } from "./CoursesCard.vue?vue&type=template&id=18dae0c8&"
import script from "./CoursesCard.vue?vue&type=script&lang=js&"
export * from "./CoursesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports